import { render, staticRenderFns } from "./LImagePlaceholder.vue?vue&type=template&id=55a3d077&scoped=true"
import script from "./LImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./LImagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LImagePlaceholder.vue?vue&type=style&index=0&id=55a3d077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3d077",
  null
  
)

export default component.exports